module.exports = __webpack_public_path__ + "img/w3_pdf_black.9903b91d.png";